import { publicAccountClient } from '../../common/client/apollo-client';
import { loader } from 'graphql.macro';
import IRegistrationRequest from '../models/registration-request-interface';
import IRegistrationResponse from '../models/registration-response-interface';

const registrationMutation: any = loader('../../../graphql/mutations/register-digital-identity-public.graphql');

class RegistrationService {
  async createUser(registrationRequest: IRegistrationRequest): Promise<IRegistrationResponse> {
    const response = await publicAccountClient().mutate<{ registerDigitalIdentityPublic: IRegistrationResponse }>({
      mutation: registrationMutation,
      variables: { input: registrationRequest },
      fetchPolicy: 'no-cache'
    });

    const registration = response?.data?.registerDigitalIdentityPublic;
    if (!registration?.requestAccepted || !registration.correlationId) {
      throw Object.assign(
        new Error(registration?.notAcceptedReason || registration?.errorKey || 'Registration request was not accepted'),
        { errorKey: registration?.errorKey }
      );
    }

    return registration;
  }
}

export default RegistrationService;

export const registrationService = new RegistrationService();
